export default "__VITE_ASSET__CJG9VvJP__"